import axios from 'services/axios-interceptors';
import { API_PATH } from 'store/service';

import Can from 'casl/can';
import * as CASL from 'casl/constants';
import OBJECTS from 'casl/objects';
import { store } from 'store';

export const myProjectsTeamsServices = {
  getAllProjectsTeamsTimesheets() {
    return Promise.all([
      ...(Can(CASL.CASL_READ, OBJECTS({}).TEAM_ADMINISTRATION_SPACE_GROUP.childrenObjects.PROJECT_MANAGER_TIMESHEETS_WAITING.id)
        ? [axios.get(API_PATH + '/timesheetEntry/getPendingWaitingProjectTimesheetsByLineManager')]
        : []),

    ]);
  },
  getPendingProjectTeamsTimesheet(payload) {
    return axios.post(API_PATH + '/timesheetEntry/post/reviewWaitingProjectTimesheetLineManager', payload);
  },
  RejectPendingProjectTeamsTimesheets(payload){
    return axios.post(API_PATH + '/timesheetEntry/post/rejectWaitingProjectTimesheetLineManager', payload)
  },
  submitSelectedPendingProjectTeamsTimesheets(payload) {
    return axios.post(API_PATH + '/timesheetEntry/post/massReviewWaitingProjectTimesheetLineManager', payload);
  },
  makeRefreshButtonEnable(enable) {
    return enable;
  }
};
